import axios from 'axios';

const get = async (url: string) => {
  const cachedData = sessionStorage.getItem(url);

  if (cachedData) {
    console.log(`Cache hit for ${url}`);
    return { data: JSON.parse(cachedData) };
  }

  const response = await axios.get(url);

  sessionStorage.setItem(url, JSON.stringify(response.data));

  return response;
};

export default get;
